namespace Core {
    class AgentNetInfoTable {
        data:NetValues;
        currency:string = TRPCONFIG.Domain.CurrencyCode;
        showTax:boolean;
        commissionType:string;
        constructor(){
            if(!this.commissionType) {
                this.commissionType = 'Commission';
            }
        }
    }

    angular
        .module('core')
        .directive('agentNetInfoTable', (): ng.IDirective => {
        return {
            restrict : 'E',
            scope: {},
            controller: AgentNetInfoTable,
            controllerAs: 'anit',
            bindToController: {
                data: '=',
                showTax: '=',
                commissionType: '@',
                mode:'@'
            },
            templateUrl: `partials/home/directivetemplate?type=AgentNetInfoTable`
        };
    });
}
